import { useRef } from "react";
import { useIntersectionObserver } from "usehooks-ts";

interface StickyProps extends React.PropsWithChildren {
  style?: React.CSSProperties;
  stuckStyle?: React.CSSProperties;
  unstuckStyle?: React.CSSProperties;
}

const Sticky: React.FC<StickyProps> = ({
  children,
  style,
  stuckStyle: stuckStyleProp,
  unstuckStyle,
}) => {
  const ref = useRef(null);
  const entry = useIntersectionObserver(ref, {
    rootMargin: "-1px 0px 0px 0px",
    threshold: 1,
  });
  const isStuck = !entry?.isIntersecting;
  const stuckStyle = {
    boxShadow: "0 4px 2px -2px rgba(0, 0, 0, 0.05)",
    ...stuckStyleProp,
  };

  return (
    <div
      ref={ref}
      style={{
        position: "sticky",
        background: "white",
        ...style,
        ...(isStuck ? stuckStyle : unstuckStyle),
      }}
    >
      {children}
    </div>
  );
};

export { Sticky };
